import { ContentComponent } from '@components/content';
import { CtaComponent } from '@components/cta';
import { FormComponent } from '@components/form';
import { GalleryComponent } from '@components/gallery';
import { HeroComponent } from '@components/hero';
import { ListComponent } from '@components/list';
import { NewsletterComponent } from '@components/newsletter';
import { NotFoundComponent } from '@components/not-found';
import { PartnerComponent } from '@components/partner';
import { StoresLocatorComponent } from '@components/stores-locator';
import { TextSeoComponent } from '@components/text-seo';
import { VideoComponent } from '@components/video';
import { VideoGridComponent } from '@components/video-grid';
import { ComponentInformations } from '@services/component-loader/model';

export const componentsToLoad: Map<string, unknown> = new Map();

const components: ComponentInformations[] = [
  {
    component: HeroComponent,
    types: ['hero', 'hero2', 'hero3', 'hero5'],
  },
  {
    component: ContentComponent,
    types: [
      'content',
      'content_image',
      'content_6',
      'content_fullscreen',
      'content2',
      'contenu_presentation_realisation',
      'content_contact',
    ],
  },
  {
    component: VideoComponent,
    types: ['video'],
  },
  {
    component: CtaComponent,
    types: ['cta', 'texte_image_cta'],
  },
  {
    component: GalleryComponent,
    types: [
      'gallery',
      'gallery_images',
      'gallery2',
      'gallery3',
      'gallery4',
      'gallery5',
      'gallery6',
      'gallery_realisation',
      'header_realisations_store',
      'store_gallery',
      'suivez_nous',
      'galerie_8_photos',
    ],
  },
  {
    component: PartnerComponent,
    types: ['partner'],
  },
  {
    component: VideoGridComponent,
    types: ['video_grid'],
  },
  {
    component: ListComponent,
    types: ['list', 'list_bloc'],
  },
  {
    component: NewsletterComponent,
    types: ['newsletter'],
  },
  {
    component: TextSeoComponent,
    types: ['textSeo', 'seo_text'],
  },
  {
    component: FormComponent,
    types: ['form'],
  },
  {
    component: StoresLocatorComponent,
    types: ['store_locator'],
  },
  {
    component: NotFoundComponent,
    types: ['bloc_404'],
  },
];

const buildComponentsToLoad = (components: ComponentInformations[]): void => {
  components.forEach((component) => {
    component.types.forEach((type) => {
      componentsToLoad.set(type, component.component);
    });
  });
};
buildComponentsToLoad(components);
